/* unplugin-vue-components disabled */import { render } from "./DashBoardLineChart.vue?vue&type=template&id=f12bb2ae&ts=true"
import script from "./DashBoardLineChart.vue?vue&type=script&lang=ts"
export * from "./DashBoardLineChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__